import apiClient from './api'

const exposeBinaryApiError = async (error) => {
  const responseData = error?.response?.data
  if (typeof Blob === 'undefined' || !(responseData instanceof Blob)) return error

  try {
    const payload = JSON.parse(await responseData.text())
    if (typeof payload?.error === 'string' && payload.error.trim()) {
      error.message = payload.error
    }
  } catch {
    // Keep the original request error if the response was not a JSON error body.
  }

  return error
}

export const receiptsApi = {

  async createReceipt(receiptData) {
    try {
      let response
      
      if (receiptData instanceof FormData) {
        
        response = await apiClient.post('/receipts', receiptData, {
          headers: {
            'Content-Type': undefined 
          }
        })
      } else {
        
        response = await apiClient.post('/receipts', receiptData)
      }
      
      return response.data
    } catch (error) {
      console.error('Fehler beim Erstellen der Quittung:', error)
      throw error
    }
  },

  async generateReceiptPreview(payload) {
    try {
      const response = await apiClient.post('/receipts/preview', payload, {
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      console.error('Fehler beim Erstellen der Quittungsvorschau:', error)
      throw error
    }
  },


  async getUserReceipts(params = {}) {
    try {
      const response = await apiClient.get('/receipts', { params })
      return response.data
    } catch (error) {
      console.error('Fehler beim Abrufen der Quittungen:', error)
      throw error
    }
  },


  async getReceiptById(id) {
    try {
      const response = await apiClient.get(`/receipts/${id}`)
      return response.data
    } catch (error) {
      console.error('Fehler beim Abrufen der Quittung:', error)
      throw error
    }
  },


  async getTeamReceipts(teamId, params = {}) {
    try {
      const response = await apiClient.get(`/teams/${teamId}/receipts`, { params })
      return response.data
    } catch (error) {
      console.error('Fehler beim Abrufen der Team-Quittungen:', error)
      throw error
    }
  },


  async deleteReceipt(id) {
    try {
      const response = await apiClient.delete(`/receipts/${id}`)
      return response.data
    } catch (error) {
      console.error('Fehler beim Löschen der Quittung:', error)
      throw error
    }
  },

  async cancelReceipt(id, reason = null) {
    try {
      const response = await apiClient.post(`/receipts/${id}/cancel`, { reason })
      return response.data
    } catch (error) {
      console.error('Fehler beim Stornieren der Quittung:', error)
      throw error
    }
  },

  async rejectReceipt(id, reason = null) {
    try {
      const response = await apiClient.post(`/receipts/${id}/reject`, { reason })
      return response.data
    } catch (error) {
      console.error('Fehler beim Ablehnen der Quittung:', error)
      throw error
    }
  },

  async reactivateCanceledReceipt(id) {
    try {
      const response = await apiClient.post(`/receipts/${id}/reactivate-canceled`)
      return response.data
    } catch (error) {
      console.error('Fehler beim Reaktivieren der stornierten Quittung:', error)
      throw error
    }
  },

  async reactivateRejectedReceipt(id) {
    try {
      const response = await apiClient.post(`/receipts/${id}/reactivate-rejected`)
      return response.data
    } catch (error) {
      console.error('Fehler beim Reaktivieren der abgelehnten Quittung:', error)
      throw error
    }
  },


  async downloadReceiptPDF(id) {
    try {
      const response = await apiClient.get(`/receipts/${id}/pdf`, {
        responseType: 'blob'
      })
      

      const contentDisposition = response.headers['content-disposition']
      const xFileName = response.headers['x-file-name']
      const xFileSize = response.headers['x-file-size']
      const contentLength = response.headers['content-length']
      let filename = 'quittung.pdf'
      let fileSize = null
      

      if (xFileName) {
        filename = xFileName
      } else if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/)
        if (filenameMatch) {
          filename = filenameMatch[1]
        }
      }
      

      if (xFileSize) {
        fileSize = parseInt(xFileSize)
      } else if (contentLength) {
        fileSize = parseInt(contentLength)
      }

      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      
      return {
        data: response.data,
        filename,
        fileSize,
        contentType: 'application/pdf'
      }
    } catch (error) {
      console.error('Fehler beim Herunterladen der PDF:', error)
      throw error
    }
  },

  async downloadReceiptCorrectionPDF(id) {
    try {
      const response = await apiClient.get(`/receipts/${id}/correction/pdf`, {
        responseType: 'blob'
      })

      const contentDisposition = response.headers['content-disposition']
      const xFileName = response.headers['x-file-name']
      const xFileSize = response.headers['x-file-size']
      const contentLength = response.headers['content-length']
      let filename = 'rechnungskorrektur.pdf'
      let fileSize = null

      if (xFileName) {
        filename = xFileName
      } else if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/)
        if (filenameMatch) {
          filename = filenameMatch[1]
        }
      }

      if (xFileSize) {
        fileSize = parseInt(xFileSize)
      } else if (contentLength) {
        fileSize = parseInt(contentLength)
      }

      const blob = new Blob([response.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)

      return {
        data: response.data,
        filename,
        fileSize,
        contentType: 'application/pdf'
      }
    } catch (error) {
      console.error('Fehler beim Herunterladen der Korrekturrechnung:', error)
      throw error
    }
  },


  async getReceiptPDFMetadata(id) {
    try {
      const response = await apiClient.get(`/receipts/${id}/pdf?metadata=true`)
      return response.data
    } catch (error) {
      console.error('Fehler beim Abrufen der PDF-Metadaten:', error)
      throw error
    }
  },

  async exportReceiptsExcel(params = {}) {
    try {
      const response = await apiClient.get('/receipts/export/excel', {
        params,
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      console.error('Fehler beim Excel-Export:', error)
      throw error
    }
  },


  async exportReceiptsZip(params = {}) {
    try {
      const response = await apiClient.get('/receipts/export/zip', {
        params,
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      console.error('Fehler beim ZIP-Export:', error)
      throw error
    }
  },


  async exportSelectedReceipts(payload) {
    try {
      const response = await apiClient.post('/receipts/export/selected', payload, {
        responseType: 'blob'
      })
      return response.data
    } catch (error) {
      console.error('Fehler beim Export der ausgewählten Quittungen:', error)
      throw error
    }
  },


  async getTeamReceiptsForAdmin(teamId, params = {}) {
    const response = await apiClient.get(`/receipts/teams/${teamId}/admin`, { params })
    return response.data
  },

  async updateReceiptPaymentStatus(receiptIds, status, paymentDate = null) {
    const response = await apiClient.put('/receipts/payment-status', {
      receiptIds,
      status,
      paymentDate
    })
    return response.data
  },

  async generateRefundFiles(payload) {

    if (Array.isArray(payload)) {
      payload = {
        receiptIds: payload,
        refundType: 'iban_excel'
      }
    }
    

    if (payload.refundType === 'iban_xml' || payload.refundType === 'iban_excel' || payload.refundType === 'paypal_excel' || payload.refundType === 'sepa_zip' || payload.refundType === 'cash_excel') {
      try {
        const response = await apiClient.post('/receipts/generate-refund-files', payload, {
          responseType: 'blob'
        })
        return response.data
      } catch (error) {
        throw await exposeBinaryApiError(error)
      }
    }
    

    const response = await apiClient.post('/receipts/generate-refund-files', payload)
    return response.data
  },

  async getRefundData(receiptIds) {
    const response = await apiClient.get('/receipts/refund-data', {
      params: { receiptIds: receiptIds.join(',') }
    })
    return response.data
  },

  /**
   * Neue Upload-Session erstellen
   */
  async createUploadSession() {
    const response = await apiClient.post('/upload-sessions');
    return response.data;
  },

  /**
   * Datei zu Upload-Session hinzufügen
   */
  async addFileToSession(sessionId, file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await apiClient.post(`/upload-sessions/${sessionId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  /**
   * Upload-Session Status abrufen
   */
  async getUploadSessionStatus(sessionId) {
    const response = await apiClient.get(`/upload-sessions/${sessionId}/status`);
    return response.data;
  },

  /**
   * Upload-Session löschen
   */
  async deleteUploadSession(sessionId) {
    const response = await apiClient.delete(`/upload-sessions/${sessionId}`);
    return response.data;
  },

  /**
   * Einzelne Datei aus Upload-Session löschen
   */
  async removeFileFromSession(sessionId, fileId) {
    const response = await apiClient.delete(`/upload-sessions/${sessionId}/files/${fileId}`);
    return response.data;
  },

  
  async downloadReceiptAttachment(receiptId, fieldName, attachmentIndex, filename = null) {
    try {
      const response = await apiClient.get(`/receipts/${receiptId}/attachments/${fieldName}/${attachmentIndex}`, {
        responseType: 'blob'
      });

      
      let downloadFilename = filename;
      if (!downloadFilename) {
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
          if (filenameMatch) {
            downloadFilename = filenameMatch[1];
          }
        }
      }
      if (!downloadFilename) {
        downloadFilename = `anhang_${fieldName}_${attachmentIndex + 1}`;
      }

      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = downloadFilename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true, filename: downloadFilename };
    } catch (error) {
      console.error('Fehler beim Herunterladen des Anhangs:', error);
      throw error;
    }
  },

  
  async getAttachmentMetadata(receiptId, fieldName, attachmentIndex) {
    try {
      const response = await apiClient.get(`/receipts/${receiptId}/attachments/${fieldName}/${attachmentIndex}?metadata=true`);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der Anhang-Metadaten:', error);
      throw error;
    }
  },

  
  async checkReceiptAccess(receiptId, email) {
    try {
      const response = await apiClient.post(`/receipts/${receiptId}/check-access`, {
        email: email
      });
      
      
      if (response.data.accessGranted && response.data.authKey) {
        localStorage.setItem(`receipt_auth_${receiptId}`, response.data.authKey);
      }
      
      return response.data;
    } catch (error) {
      console.error('Fehler bei der Zugriffsüberprüfung:', error);
      throw error;
    }
  },

  
  getReceiptAuthKey(receiptId) {
    return localStorage.getItem(`receipt_auth_${receiptId}`);
  },

  
  clearReceiptAuthKey(receiptId) {
    localStorage.removeItem(`receipt_auth_${receiptId}`);
  },

  
  async getPublicReceipt(receiptId) {
    try {
      const authKey = this.getReceiptAuthKey(receiptId);
      if (!authKey) {
        throw new Error('Kein Auth-Key verfügbar');
      }

      const response = await apiClient.get(`/receipts/public/${receiptId}`, {
        headers: {
          'X-Receipt-Auth': authKey
        }
      });
      return response.data;
    } catch (error) {
      console.error('Fehler beim Abrufen der öffentlichen Quittung:', error);
      throw error;
    }
  },

  
  async downloadPublicReceiptPDF(receiptId) {
    try {
      const authKey = this.getReceiptAuthKey(receiptId);
      if (!authKey) {
        throw new Error('Kein Auth-Key verfügbar');
      }

      const response = await apiClient.get(`/receipts/public/${receiptId}/pdf`, {
        headers: {
          'X-Receipt-Auth': authKey
        },
        responseType: 'blob'
      });

      
      const contentDisposition = response.headers['content-disposition'];
      const xFileName = response.headers['x-file-name'];
      const xFileSize = response.headers['x-file-size'];
      const contentLength = response.headers['content-length'];
      let filename = 'quittung.pdf';
      let fileSize = null;

      if (xFileName) {
        filename = xFileName;
      } else if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      if (xFileSize) {
        fileSize = parseInt(xFileSize);
      } else if (contentLength) {
        fileSize = parseInt(contentLength);
      }

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      return {
        data: response.data,
        filename,
        fileSize,
        contentType: 'application/pdf'
      };
    } catch (error) {
      console.error('Fehler beim Herunterladen der öffentlichen PDF:', error);
      throw error;
    }
  },

  
  async downloadPublicReceiptAttachment(receiptId, fieldName, attachmentIndex, filename = null) {
    try {
      const authKey = this.getReceiptAuthKey(receiptId);
      if (!authKey) {
        throw new Error('Kein Auth-Key verfügbar');
      }

      const response = await apiClient.get(`/receipts/public/${receiptId}/attachments/${fieldName}/${attachmentIndex}`, {
        headers: {
          'X-Receipt-Auth': authKey
        },
        responseType: 'blob'
      });

      
      let downloadFilename = filename;
      if (!downloadFilename) {
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
          if (filenameMatch) {
            downloadFilename = filenameMatch[1];
          }
        }
      }
      if (!downloadFilename) {
        downloadFilename = `anhang_${fieldName}_${attachmentIndex + 1}`;
      }

      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = downloadFilename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true, filename: downloadFilename };
    } catch (error) {
      console.error('Fehler beim Herunterladen des öffentlichen Anhangs:', error);
      throw error;
    }
  }
} 
